import fetch from 'auth/FetchInterceptor';

const AuthService = {};

AuthService.login = function (data) {
  return fetch({
    url: '/auth/login',
    method: 'post',
    data: data
  });
};

AuthService.register = function (data) {
  return fetch({
    url: '/auth/create',
    method: 'post',
    data: data
  });
};

AuthService.requestOtp = function (data) {
  return fetch({
    url: '/auth/request-otp',
    method: 'post',
    data: data
  });
};

AuthService.resetPasswordWithOtp = function (data) {
  return fetch({
    url: '/auth/reset-password/request-otp',
    method: 'post',
    data: data
  });
};

AuthService.verifyPasswordWithOtp = function (data) {
  return fetch({
    url: '/user/otp/reset-password/public',
    method: 'put',
    data: data
  });
};

AuthService.loginWithOtp = function (data) {
  return fetch({
    url: '/auth/login-with-otp',
    method: 'post',
    data: data
  });
};

AuthService.logout = function (data) {
  return fetch({
    url: '/auth/logout',
    method: 'post',
    data
  });
};

AuthService.loginInOAuth = function () {
  return fetch({
    url: '/auth/loginInOAuth',
    method: 'post'
  });
};

AuthService.profile = function () {
  return fetch({
    url: '/auth/profile',
    method: 'GET'
  });
};

AuthService.resetUserPassword = function (data) {
  return fetch({
    url: '/user/password/reset',
    method: 'put',
    data
  });
};

export default AuthService;
